import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getOrdersDispatches, generateFax, generateInvoice, generateEway, cancelEway, generateEInvoice, cancelEInvoice, downloadMergedInvoiceEwayPdf, regenerateInvoice, generateSlip, generateFaxWithoutDealer, updateAmountInLedger } from '@/api/orders-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Inr from '@/components/Inr/index.vue';
import DispatchList from './components/DispatchList.vue';
import { getAdmins } from '@/api/admins';
import { getUnits } from '@/api/locations/units';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import Axios from 'axios';
import router from '@/router';
import { searchProducts } from '@/api/products';
import { getBranches } from '@/api/locations/branches';
import moment from 'moment';
import { cleanListQuery, isAdmin, isBranchManager, isExcludedToAccess, isInvoiceAndUnitManager, isSuperAdmin, isZonalManager } from '@/common';
import { BranchAgentService } from '@/services/branch-agent-service';
import * as XLSX from 'xlsx';
import { UNIT_MANAGER } from '@/constants/roles.constants';
import { equivalentDealersToBranches } from '@/constants/equivalentDealersToBranches.constants';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.productListLoading = false;
    this.products = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.dateRange = '';
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.unitManagers = [];
    this.unitList = [];
    this.dealerList = [];
    this.dealerListLoading = false;
    this.selectedProduct = null;
    this.filteredProducts = [];
    this.isAllSelected = false;
    this.showFilters = false;
    this.agentList = [];
    this.statusOptions = ['Pending', 'Request Approval', 'Approved', 'Rejected', 'In Transit'];
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.isBranchMap = {
      true: 'success',
      false: 'warning'
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      unitId: undefined,
      adminId: undefined,
      agentId: undefined,
      status: undefined,
      entryNumber: undefined,
      createdTimestamp: undefined,
      branchId: undefined,
      transitToApprove: undefined,
      applyBranchIdFilter: true,
      'dealer.isUnit': undefined,
      'ordersProductsDispatch.ordersProduct.productsVariationId': undefined,
      'ordersProductsDispatch.ordersProduct.productId': undefined,
      sort: 'id,DESC',
      filter: {
        dealerId: '$eq',
        unitId: '$eq',
        adminId: '$eq',
        agentId: '$eq',
        status: '$eq',
        branchId: '$in',
        'ordersProductsDispatch.ordersProduct.productsVariationId': '$eq',
        'ordersProductsDispatch.ordersProduct.productId': '$eq',
        entryNumber: '$contL',
        createdTimestamp: 'between',
        transitToApprove: '$eq',
        'dealer.isUnit': '$eq'
      }
    };
    this.transitToApproveOptions = [{
      key: true,
      value: 'Yes'
    }, {
      key: false,
      value: 'No'
    }];
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.branchDealerOptions = [{
      key: true,
      value: 'Branches'
    }, {
      key: false,
      value: 'Dealers'
    }];
    this.assignedBranches = [] || null;
    this.loggedInAdmin = null;
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
  }
  isExcludedForUnitRole() {
    const requiredRoles = [3]; // 3-> unit manager , 4-> Invoice manager
    return !requiredRoles.some(roleId => AdminModule.adminsRoleIds.includes(roleId));
  }
  _isInvoiceAndUnitManager() {
    return isInvoiceAndUnitManager();
  }
  _isBranchOrZonalManager() {
    return isBranchManager() || isZonalManager();
  }
  async activated() {
    this.loggedInAdmin = AdminModule;
    // Extract branchId from the URL
    const branchIdFromURL = this.$route.query.branchId;
    // If branchId exists in the URL, assign it
    if (branchIdFromURL) {
      this.listQuery.branchId = branchIdFromURL;
    }
    // this.listQuery.branchId = await BranchAgentService.assignBranchId();
    this.assignedBranches = await BranchAgentService.assignBranchId();
    // Check if branchId is null and throw an error
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
    // check if logged in user is Agent/Admin
    if (this.loggedInAdmin.userType === 'Agent') {
      this.isAgent = true;
      this.listQuery.agentId = this.loggedInAdmin.agentId;
    }
    // check if admin id
    if (this.loggedInAdmin.adminsRoleIds.includes(UNIT_MANAGER)) {
      this.listQuery.adminId = this.loggedInAdmin.id;
      // adding or condition to get current branch dispatches
      const depoDispatchDealerIds = [];
      const assignedBranchIds = this.branchList.map(branch => branch.id);
      for (const branchId of assignedBranchIds) {
        depoDispatchDealerIds.push(equivalentDealersToBranches[branchId]);
      }
      // this.listQuery.or.dealerId = depoDispatchDealerIds;
      // this.listQuery.or.status = "In Transit";
    }
    if (this.$route.query.status) {
      this.listQuery.status = this.$route.query.status;
    }
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange = {
        start: this.$route.query.startDate,
        end: this.$route.query.endDate
      };
    }
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    // get unit managers
    this.fetchUnitManagers();
    if (!this.listQuery.adminId) {
      this.fetchAllUnitList();
    }
    // get dispatch list
    this.getList();
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      const data = await getOrdersDispatches(getQuery(this.listQuery));
      this.list = data.data.filter((item, index) => {
        if (item.status === 'Pending') {
          return true; // Include all "Pending" items without checking for duplicates
        }
        return data.data.findIndex(otherItem => otherItem.entryNumber === item.entryNumber) === index;
      });
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchBranches(superAdmin = true) {
    this.branchListLoading = true;
    // Base query
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    //  filter only if superAdmin is false
    if (!superAdmin) {
      if (this.listQuery.branchId.length === 0) {
        this.listQuery.branchId = AdminModule.branchIds;
      }
      query.id = this.listQuery.branchId;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    // Fetch branch list
    this.branchList = await getBranches(getQuery(query));
    this.branchListLoading = false;
  }
  async downloadFax() {
    this.listLoading = true;
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      const params = {};
      if (this.listQuery.adminId) {
        params.adminId = this.listQuery.adminId;
      }
      if (this.listQuery.branchId) {
        params.branchId = this.listQuery.branchId;
        // Check if branchId has a filter property and if it's valid
        if (this.listQuery.branchId.filter) {
          params.filter = {
            branchId: '$in'
          };
        }
      }
      if (this.listQuery.unitId) {
        params.unitId = this.listQuery.unitId;
      }
      if (this.isAllSelected) {
        params.selectedAll = true;
      }
      if (this.listQuery.dealerId) {
        params.dealerId = this.listQuery.dealerId;
      }
      if (this.listQuery.agentId) {
        params.agentId = this.listQuery.agentId;
      }
      if (this.listQuery.status) {
        params.status = this.listQuery.status;
      }
      if (this.dateRange) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      try {
        const data = await generateFax(getQuery(params));
        if (data && data.url) {
          window.open(data.url, '_blank'); // Fixed typo: "*blank" to "_blank"
        } else {
          this.$message({
            message: 'Error generating fax: Invalid response',
            type: 'error'
          });
        }
      } catch (apiError) {
        this.$message({
          message: `Error calling API: ${apiError || 'Unknown error'}`,
          type: 'error'
        });
      }
    } catch (error) {
      this.$message({
        message: `Error: ${error || 'Unknown error'}`,
        type: 'error'
      });
    } finally {
      this.listLoading = false;
    }
  }
  async downloadFaxWithoutDealer() {
    this.listLoading = true;
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      const params = {};
      if (this.listQuery.adminId) {
        params.adminId = this.listQuery.adminId;
      }
      if (this.listQuery.branchId) {
        params.branchId = this.listQuery.branchId;
        // Check if branchId has a filter property and if it's valid
        if (this.listQuery.branchId.filter) {
          params.filter = {
            branchId: '$in'
          };
        }
      }
      if (this.listQuery.unitId) {
        params.unitId = this.listQuery.unitId;
      }
      if (this.isAllSelected) {
        params.selectedAll = true;
      }
      if (this.listQuery.dealerId) {
        params.dealerId = this.listQuery.dealerId;
      }
      if (this.listQuery.status) {
        params.status = this.listQuery.status;
      }
      if (this.dateRange) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      try {
        const data = await generateFaxWithoutDealer(getQuery(params));
        if (data && data.url) {
          window.open(data.url, '_blank'); // Fixed typo: "*blank" to "_blank"
        } else {
          this.$message({
            message: 'Error generating fax: Invalid response',
            type: 'error'
          });
        }
      } catch (apiError) {
        this.$message({
          message: `Error calling API: ${apiError || 'Unknown error'}`,
          type: 'error'
        });
      }
    } catch (error) {
      this.$message({
        message: `Error: ${error || 'Unknown error'}`,
        type: 'error'
      });
    } finally {
      this.listLoading = false;
    }
  }
  async downloadSlip() {
    this.listLoading = true;
    try {
      const params = {};
      if (this.listQuery.adminId) {
        params.adminId = this.listQuery.adminId;
      }
      if (this.listQuery.branchId) {
        params.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.branchId.filter) {
        params.filter = {
          branchId: '$in'
        };
      }
      if (this.listQuery.unitId) {
        params.unitId = this.listQuery.unitId;
      }
      if (this.isAllSelected) {
        params.selectedAll = true;
      }
      if (this.listQuery.dealerId) {
        params.dealerId = this.listQuery.dealerId;
      }
      if (this.listQuery.status) {
        params.status = this.listQuery.status;
      }
      if (this.dateRange) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      if (Object.keys(params).length) {
        const data = await generateSlip(getQuery(params));
        window.open(data.url, '_blank');
        // const filename: string = "fax_" + new Date().getTime() + ".pdf";
        // this.downloadFile(data.url, filename);
      } else {
        this.$message({
          message: 'Please select atleast one filter',
          type: 'warning'
        });
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchUnitManagers() {
    let managerUnitId;
    // if adding & logged in user is unit manager
    // if (this.loggedInAdmin.adminsRoleId === 3) {
    if (this.loggedInAdmin.roles.includes('Unit Manager')) {
      managerUnitId = this.loggedInAdmin.id;
      // set to form data
      this.listQuery.adminId = await this.loggedInAdmin.id;
      // fetch units as per manager
      await this.fetchUnitList(managerUnitId);
    }
    const result = await getAdmins(getQuery({
      id: managerUnitId,
      enabled: true,
      adminsRoleId: 3,
      filter: {
        id: '$eq',
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.unitManagers = result.data;
  }
  async fetchUnitList(adminId = 0, branchId = 0) {
    try {
      // if (branchId == 0) {
      //   await this.handleClearBranch();
      //   branchId = await this.listQuery.branchId;
      // }
      this.unitList = await getUnits(getQuery({
        enable: true,
        'admin.id': adminId,
        branchId: branchId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          'admin.id': '$eq',
          branchId: '$in'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  async fetchAllUnitList() {
    try {
      this.unitList = await getUnits(getQuery({
        enable: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
      const all = {
        name: 'Select All',
        id: 0,
        code: 'SA'
      };
      this.unitList.unshift(all);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  isButtonDisabled() {
    // Get today's midnight
    const todayMidnight = moment().startOf('day');
    // Get current time
    const now = moment();
    // Disable if current time is >= today's midnight (which means it's past midnight)
    return now.isSameOrAfter(todayMidnight);
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        this.products = await searchProducts(getQuery({
          keyword: query
        }));
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  handleProductSelection(value) {
    if (value) {
      if (value.startsWith('product-')) {
        this.listQuery['ordersProductsDispatch.ordersProduct.productId'] = +value.replace('product-', '');
        this.listQuery['ordersProductsDispatch.ordersProduct.productsVariationId'] = undefined;
      } else if (value.startsWith('variation-')) {
        this.listQuery['ordersProductsDispatch.ordersProduct.productId'] = undefined;
        this.listQuery['ordersProductsDispatch.ordersProduct.productsVariationId'] = +value.replace('variation-', '');
      }
    } else {
      // Clear the product filters when value is null or empty
      this.listQuery['ordersProductsDispatch.ordersProduct.productId'] = undefined;
      this.listQuery['ordersProductsDispatch.ordersProduct.productsVariationId'] = undefined;
    }
    this.handleFilter();
  }
  // private async handleClearBranch() {
  //   // Assign branchId using BranchAgentService
  //   this.listQuery.branchId = await BranchAgentService.assignBranchId();
  //   // Fetch branches for non-super admin users
  //   this.branchList = await BranchAgentService.fetchBranches(
  //     this.listQuery.branchId
  //   );
  // }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange) {
      // Convert the start and end of the date range to UTC
      const startDateUTC = new Date(this.dateRange.start).toISOString();
      const endDateUTC = new Date(this.dateRange.end).toISOString();
      // Assign the date range as UTC timestamps to the list query
      this.listQuery.createdTimestamp = [startDateUTC, endDateUTC].join(',');
    } else {
      // If no date range is provided, set createdTimestamp to undefined
      this.listQuery.createdTimestamp = undefined;
    }
    // fetch units if unit manager selected according to branch
    if (this.listQuery.adminId && this.listQuery.branchId) {
      this.fetchUnitList(this.listQuery.adminId, this.listQuery.branchId);
    } else {
      this.fetchAllUnitList();
    }
    if (this.listQuery.unitId === 0) {
      this.isAllSelected = true;
      this.listQuery.unitId = undefined;
    } else {
      this.isAllSelected = false;
    }
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      await this.getList();
    } else {
      // await this.handleClearBranch();
      await this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await generateInvoice(id);
    if (url) {
      window.open(url, '_blank');
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
  async generateBill(id = 0, module = null) {
    this.listLoading = true;
    let url = null;
    if (module === 'way') {
      const ewayRes = await generateInvoice(id);
      if (ewayRes && ewayRes.status === 'success') {
        url = ewayRes.data;
      }
    } else if (module === 'einvoice') {
      const eInvoiceRes = await generateInvoice(id);
      if (eInvoiceRes && eInvoiceRes.status === 'success') {
        url = eInvoiceRes.data.EinvoicePdf;
      }
    }
    if (url) {
      window.open(url, '_blank');
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
  downloadFile(url, filename) {
    Axios.get(url, {
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      this.$message({
        message: error,
        type: 'error'
      });
    });
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Full Name', 'Email', 'Mobile Number', 'Status', 'timestamp'];
    const filterVal = ['id', 'fullName', 'emailAddress', 'mobileNumber', 'enabled', 'createdTimestamp'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.adminManagement.admins.title'));
    this.downloadLoading = false;
  }
  async handleExcelDownload() {
    this.downloadLoading = true;
    try {
      const query = this.listQuery;
      let startDate = '';
      let endDate = '';
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      if (this.listQuery.startDate && this.listQuery.endDate) {
        startDate = this.listQuery.startDate;
        endDate = this.listQuery.endDate;
      }
      const data = await getOrdersDispatches(getQuery(queryWithoutPagination));
      const list = data.filter((item, index) => data.findIndex(otherItem => otherItem.entryNumber === item.entryNumber) === index);
      // Prepare data for Excel
      const excelData = list.map(item => {
        var _item$dealer, _item$dealer2, _item$unit, _item$dealer3, _item$agent;
        return {
          'Lot Number': (item === null || item === void 0 ? void 0 : item.entryNumber) || '',
          Carton: +(item === null || item === void 0 ? void 0 : item.totalCartonCount) || '',
          'Dealer Name': ((_item$dealer = item.dealer) === null || _item$dealer === void 0 ? void 0 : _item$dealer.name) || '',
          'Dealer City': ((_item$dealer2 = item.dealer) === null || _item$dealer2 === void 0 ? void 0 : _item$dealer2.city) || '',
          Unit: ((_item$unit = item.unit) === null || _item$unit === void 0 ? void 0 : _item$unit.name) || '',
          'Private Marka': (item === null || item === void 0 ? void 0 : item.privateMarka) || ((_item$dealer3 = item.dealer) === null || _item$dealer3 === void 0 ? void 0 : _item$dealer3.privateMarka) || '',
          Agent: (item === null || item === void 0 ? void 0 : item.agent.name) || '',
          'Agent Code': (item === null || item === void 0 || (_item$agent = item.agent) === null || _item$agent === void 0 ? void 0 : _item$agent.code) || ''
        };
      });
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      // Create a workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders Dispatches');
      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob = new Blob([excelBuffer], {
        type: 'application/octet-stream'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Orders_Dispatches.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.$message.success('Excel file downloaded successfully');
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      this.downloadLoading = false;
    }
  }
  async createEInvoice(id = 0) {
    // generate E-invoice
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create E-invoice?', 'Create E-invoice', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEInvoiceResponse = await generateEInvoice(id);
        if (generateEInvoiceResponse && generateEInvoiceResponse.status === 'success') {
          this.$message({
            message: 'E-invoice created successfully',
            type: 'success'
          });
          // refresh list to display einvoice data
          this.getList();
        } else {
          this.$message({
            message: `Failed to create E-invoice: ${generateEInvoiceResponse.message}`,
            type: 'error'
          });
          this.downloadJsonFile(generateEInvoiceResponse.payload, 'einvoice-payload');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async cancelEInvoice(id = 0) {
    // cancel E-invoice
    try {
      this.listLoading = true;
      this.$confirm('Do you want to cancel E-invoice?', 'Cancel E-invoice', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const cancelEInvoiceResponse = await cancelEInvoice(id);
        if (cancelEInvoiceResponse && cancelEInvoiceResponse.status === 'success') {
          this.$message({
            message: 'E-invoice cancelled successfully',
            type: 'success'
          });
          // refresh list to display einvoice data
          this.getList();
        } else {
          this.$message({
            message: 'Failed to cancel E-invoice',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async createEWay(id = 0) {
    // generate E-way
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create E-way?', 'Create E-way', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEWayResponse = await generateEway(id);
        if (generateEWayResponse && generateEWayResponse.status === 'success') {
          this.$message({
            message: 'E-way created successfully',
            type: 'success'
          });
          // refresh list to display eway data
          this.getList();
        } else {
          this.$message({
            message: `${generateEWayResponse.message}`,
            type: 'error'
          });
          this.downloadJsonFile(generateEWayResponse.payload, 'eway-payload');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      console.log(err);
      this.listLoading = false;
    }
  }
  async cancelEWay(id = 0) {
    // cancel E-way
    try {
      this.listLoading = true;
      this.$confirm('Do you want to cancel E-way?', 'Cancel E-way', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const cancelEWayResponse = await cancelEway(id);
        if (cancelEWayResponse && cancelEWayResponse.status === 'success') {
          this.$message({
            message: 'E-way cancelled successfully',
            type: 'success'
          });
          // refresh list to display eway data
          this.getList();
        } else {
          this.$message({
            message: 'Failed to cancel E-way',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  downloadJsonFile(data, filename) {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}-${new Date().toISOString()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      // first column
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      // quantity & Grand Total column
      if (index === 5 || index === 6) {
        // get all values
        const values = data.map(item => Number(item[column.property]));
        // loop over & null check
        if (!values.every(value => isNaN(value))) {
          // sum  them using reduce
          sums[index] = values.reduce((prev, curr) => {
            // value conversion (do check with Sandesh if toFixed something else required for decimal precision)
            const value = Number(curr);
            // null check
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0); // initial value
        } // loop if ends
      } // index check ends
    }); // columm loop ends
    // return sums
    return sums;
  }
  async downloadMergedPdf(id = 0) {
    // get invoice url
    this.listLoading = true;
    try {
      const data = await downloadMergedInvoiceEwayPdf(id);
      if (data) {
        window.open(data, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  showUpdateEwayDialogCondition(data) {
    // check if cancel date is present
    if (data.ewayCancelDate) {
      return false;
    }
    let disableUpdateEwayOption = true;
    let dateConditionCheck = false;
    // Add 7 days to the eWayBillDate
    const canUpdateEwayTillDate = this.$moment(data.ewayBillDate, 'YYYY-MM-DDTHH:mm:ss.SSS').add(7, 'days').format('YYYY-MM-DDTHH:mm:ss.SSS');
    const currentDate = this.$moment().format('YYYY-MM-DDTHH:mm:ss.SSS');
    if (this.$moment(currentDate).isBefore(this.$moment(canUpdateEwayTillDate, 'YYYY-MM-DDTHH:mm:ss.SSS'))) {
      dateConditionCheck = true;
    }
    if (data.ewayBillNo && !data.ewayCancelDate && dateConditionCheck) {
      disableUpdateEwayOption = false;
    }
    return disableUpdateEwayOption;
  }
  goTo(url) {
    router.push({
      path: url
    });
  }
  getFormatedURL(url = null) {
    if (!url) {
      return '#';
    }
    // Check if the URL starts with 'https://'
    if (!url.startsWith('https://')) {
      // If it does not start with 'http://' or 'https://', prepend 'https://'
      if (!url.startsWith('http://')) {
        url = 'https://' + url;
      } else {
        // If it starts with 'http://', replace 'http://' with 'https://'
        url = url.replace('http://', 'https://');
      }
    }
    return url;
  }
  async updateAmountInLedger(id) {
    try {
      await updateAmountInLedger(id);
      this.$message.success('Invoice Amount updated in Ledgers successfully');
    } catch (error) {
      this.$message.error('Error Updating the ledger amount');
    }
  }
  async regenerateInvoiceToS3(id) {
    try {
      await regenerateInvoice(id);
      this.$message.success('Invoice regenerated successfully');
    } catch (error) {
      this.$message.error('Error regenerating the invoice');
    }
  }
  isSuperAdmin() {
    // @Todo: Need to change this to id basis.
    return ['Super Admin'].includes(AdminModule.roles.toString());
  }
};
default_1 = __decorate([Component({
  name: 'OrdersDispatchList',
  components: {
    Pagination,
    Inr,
    DispatchList
  }
})], default_1);
export default default_1;